import { render, staticRenderFns } from "./XdScheduleList.vue?vue&type=template&id=0bc484c6&scoped=true&"
import script from "./XdScheduleList.vue?vue&type=script&lang=js&"
export * from "./XdScheduleList.vue?vue&type=script&lang=js&"
import style0 from "./XdScheduleList.vue?vue&type=style&index=0&id=0bc484c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc484c6",
  null
  
)

export default component.exports